import React from 'react';
import Home from '../Home';

const Mainhome = () => {
    return (
        <div className='container my-3'>
            <h5 className='text-white mb-2 mx-auto fw-bold headerText'>Nabiul-<span className='text-clor-for-all'>Portfolio</span></h5>
            <Home></Home>
        </div>
    );
};

export default Mainhome;